
import EDDivider from '../../../../BaseComponents/Divider/EDDivider';

const ObjectSubCard: React.FC<React.PropsWithChildren<{}>> = props => {
  return (
    <>
      <EDDivider
        marginTop={2}
        marginBottom={1}
        marginX={-2}
        variant="fullWidth"
      />
      {props.children}
    </>
  );
};

export default ObjectSubCard;
